import { useLazyQuery } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  DATE_FORMATS,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { formatDate, hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import LoaderComponent from '../../../../../components/LoaderComponent';
import Portal from '../../../../../components/Portal';
import StaffForm from '../../sales/components/SalesTeamForm';
import { STAFF_USER } from '../graphql/Queries';
import {
  LIBRARY_STAFF_BASE_PATH,
  STAFF_ROLES,
  getStaffRole,
} from '../staffConfig';

const ViewStaff = (props) => {
  const { match: { params: { id } = {} } = {} } = props;
  const {
    state: { permissions },
  } = useContext(AppContext);

  const [form] = Form.useForm();
  const history = useHistory();
  const location = useLocation();
  const { returnPath = LIBRARY_STAFF_BASE_PATH } = location?.state || {};
  const [staffDetail, setStaffDetail] = useState({});
  const [isStaffLoading, setIsStaffLoading] = useState(true);

  const [fetchUser] = useLazyQuery(STAFF_USER, {
    onCompleted: (response) => {
      setStaffDetail(response?.user);
      setIsStaffLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setIsStaffLoading(false);
    },
  });

  useEffect(() => {
    setIsStaffLoading(true);
    fetchUser({ variables: { where: { id } } });
  }, []);

  const canEdit = hasPermission(
    PERMISSIONS_KEY?.SYSTEM_USERS_ADMINS,
    PERMISSION_TYPE?.UPDATE,
    permissions,
  );

  const initialValues = {
    ...staffDetail,
    contact: staffDetail?.contactNo,
    pincode: staffDetail?.pincode?.pincode,
    staffLibraryId: staffDetail?.libraryStaff?.library?.id,
    staffRole:
      staffDetail?.libraryStaff?.role || getStaffRole(staffDetail?.roles),
  };

  const headerButtons = canEdit && (
    <div className="header-btn-wrapper">
      <Button
        className="common-button mr-16"
        size="middle"
        onClick={() =>
          history?.push(`${LIBRARY_STAFF_BASE_PATH}/edit/${id}`, {
            returnPath,
          })
        }
        disabled={staffDetail?.isArchived}
      >
        Edit Library Staff
      </Button>
    </div>
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={returnPath} />
        <div className="portal-header">View Library Staff</div>
      </Portal>
      <Portal portalId="header-right-content">{headerButtons}</Portal>
      <Portal portalId="header-right-content-phones">{headerButtons}</Portal>
      <Card
        className="full-height-with-nav"
        title="Library Staff Details"
        extra={
          <strong>
            Onboarded On :{' '}
            {formatDate(staffDetail?.createdAt, DATE_FORMATS?.ONBOARD) || '-'}
          </strong>
        }
      >
        {isStaffLoading ? (
          <LoaderComponent size="large" setHeight="60" spinning />
        ) : (
          <div className="delivery-form">
            <StaffForm
              form={form}
              initialValues={initialValues}
              isView
              deliveryDetail={staffDetail}
              showLibrary
              roleOptions={STAFF_ROLES}
            hideCountry
              libraryData={staffDetail?.libraryStaff?.library}
            />
          </div>
        )}
      </Card>
    </>
  );
};

export default ViewStaff;
